<mat-card appearance="outlined">
  <div echarts [options]="chartOption" class="chart"></div>
</mat-card>
<mat-card appearance="outlined" class="mt-2">
  <table class="col-12">
    <thead>
      <tr class="table-header">
        <td>Servisna grupa</td>
        <td>Naziv</td>
        <td>Broj naloga</td>
      </tr>
    </thead>
    <tr *ngFor="let podatak of dokumenti" class="table-row">
      <td>{{podatak.serviser}}</td>
      <td>{{podatak.naziv}}</td>
      <td class="text-right">{{podatak.broj}}</td>
    </tr>
    <tr class="table-footer">
      <td>Ukupno</td>
      <td></td>
      <td class="text-right">{{ukupno}}</td>
    </tr>
  </table>
</mat-card>
